__webpack_require__.p = "/hotelfan/";